import { useQuery } from '@tanstack/react-query';
import { useInjection } from 'inversify-react';
import type { IGoodsReceivingService } from '../../../services/goods-receiving';
import { GoodsReceivingService } from '../../../services/goods-receiving';
import { goodsReceivingQueryKeys } from '../query-keys';

/**
 * Hook per recuperare la lista di fornitori.
 * Utilizza TanStack React Query per la gestione dello stato e del caching.
 *
 * @returns Query result con array di Supplier
 */
export function useSuppliers() {
  const service = useInjection<IGoodsReceivingService>(GoodsReceivingService);

  return useQuery({
    queryKey: goodsReceivingQueryKeys.suppliers(),
    queryFn: async () => {
      return service.getSuppliers();
    },
  });
}
